import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { LEAD_FORM_CONVERSION_EVENT_NAME } from 'site-modules/shared/components/evolv/constants';

/**
 * Renders telephone link w/ or w/o text based on `showNumber` flag.
 * @param {String} linkClassName
 * @param {String} icon
 * @param {String} formattedPhone
 * @param {String} iconClassName
 * @param {Object} dealerInfo
 * @param {Boolean} showNumber
 * @param {Boolean} isRedesign
 * @returns {ReactElement}
 */
export function TelephoneLink({
  linkClassName = '',
  icon = 'phone2',
  formattedPhone = '',
  dealerInfo,
  iconClassName = 'text-gray-dark',
  iconClassNames = '',
  iconWrapperClasses = '',
  showNumber = false,
  telephoneLinkCTAName = '',
  isRedesign = false,
}) {
  const [isCTAClicked, setIsCTAClicked] = useState(false);

  const handleClickCTATextChange = e => {
    e.preventDefault();
    setIsCTAClicked(true);
  };

  if (!formattedPhone) {
    return null;
  }
  const { dataTrackingId, dataDealerFranchiseId, dataDealerRooftopId } = dealerInfo;

  const telephoneLinkContent = (
    <span>
      {showNumber ? (
        <Fragment>
          <i className={classnames('me-0_25', `icon-${icon}`, iconClassNames)} aria-hidden /> {formattedPhone}
        </Fragment>
      ) : (
        <Fragment>
          <i className={classnames('me-0_25', `icon-${icon}`, iconClassName)} aria-hidden />
          <span className="d-lg-none d-xl-inline">Call </span>
          <span className="d-md-none">Dealer </span>
          <span className="d-none d-md-inline">{formattedPhone}</span>
        </Fragment>
      )}
    </span>
  );

  const telephoneLinkContentCTA = (
    <Fragment>
      {isRedesign ? (
        <div
          className={classnames(
            'circle-btn rounded-circle d-inline-flex justify-content-center align-items-center me-0_5',
            iconWrapperClasses
          )}
        >
          <i className={classnames(`icon-${icon}`, iconClassNames)} aria-hidden />
        </div>
      ) : (
        <i className={classnames('me-0_25', `icon-${icon}`, iconClassName)} aria-hidden />
      )}
      <span>{isCTAClicked ? formattedPhone : telephoneLinkCTAName}</span>
    </Fragment>
  );

  return (
    <a
      className={linkClassName}
      href={`tel:${formattedPhone}`}
      data-tracking-id={dataTrackingId}
      data-dealer-franchise-id={dataDealerFranchiseId}
      data-dealer-rooftop-id={dataDealerRooftopId}
      data-evolv-conversion={LEAD_FORM_CONVERSION_EVENT_NAME}
      {...(telephoneLinkCTAName
        ? {
            onClick: isCTAClicked ? null : handleClickCTATextChange,
            'data-tracking-ignore-value': true,
          }
        : {})}
    >
      {telephoneLinkCTAName ? telephoneLinkContentCTA : telephoneLinkContent}
    </a>
  );
}

TelephoneLink.propTypes = {
  linkClassName: PropTypes.string,
  iconClassName: PropTypes.string,
  iconClassNames: PropTypes.string,
  iconWrapperClasses: PropTypes.string,
  icon: PropTypes.string,
  formattedPhone: PropTypes.string,
  dealerInfo: PropTypes.shape({
    dataTrackingId: PropTypes.string,
    dataDealerFranchiseId: PropTypes.string,
    dataDealerRooftopId: PropTypes.number,
  }).isRequired,
  showNumber: PropTypes.bool,
  telephoneLinkCTAName: PropTypes.string,
  isRedesign: PropTypes.bool,
};
